<template><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
	<rect x="15" width="1" height="16" />
	<rect x="6" y="2" width="7" height="5" />
	<rect y="9" width="13" height="5" />
</svg>
</template>